<template>
  <div>
    <!-- 审核 -->
    <div v-if="status === 'verify'" style="margin-top: 40px">
      <el-divider class="cml-divider" content-position="center"
        >{{ statusName }}意见</el-divider
      >
      <el-form
        :model="verifyFormData"
        :rules="verifyRules"
        ref="verifyFormData"
        label-width="300px"
      >
        <el-form-item label="审核结果" prop="checkStatus">
          <el-select
            v-model="verifyFormData.checkStatus"
            placeholder="请选择"
            @change="checkStatusChange"
          >
            <el-option value="PASS" label="审核通过"></el-option>
            <el-option value="NO_PASS" label="审核不通过"></el-option>
          </el-select>
        </el-form-item>
        <el-form-item
          v-if="verifyFormData.checkStatus === 'PASS'"
          label="采购仓库是否有实物"
          prop="companyHave"
        >
          <DictSelect
            type="cml_common_whether"
            :value="verifyFormData.companyHave"
            @change-emit="companyHaveChange"
          />
        </el-form-item>
        <el-form-item
          v-if="verifyFormData.companyHave === 'YES'"
          label="实物存放位置"
          prop="storageLocation"
        >
          <el-input
            v-model.trim="verifyFormData.storageLocation"
            :maxlength="maxlength"
          ></el-input>
        </el-form-item>
        <el-form-item
          v-if="verifyFormData.checkStatus === 'NO_PASS'"
          label="审核不通过原因"
          prop="rejectMark"
        >
          <el-input
            v-model.trim="verifyFormData.rejectMark"
            :maxlength="maxlength"
          ></el-input>
        </el-form-item>
      </el-form>
      <div v-if="status === 'verify'">
        <el-button
          size="medium"
          style="margin: 20px 0 50px 300px"
          @click="
            toSamplePage(
              'toListTab1',
              'sample-manage/verify-sample',
              '审核样品',
            )
          "
          >取消</el-button
        >
        <el-button
          type="primary"
          size="medium"
          style="margin-left: 20px"
          :loading="saveLoading"
          @click="verifyBtn"
          >提交</el-button
        >
      </div>
    </div>
  </div>
</template>
<script>
import DictSelect from '@/components/DictSelect';

export default {
  components: {
    DictSelect,
  },
  props: {
    status: {
      type: String,
      default: '',
    },
    statusName: {
      type: String,
      default: '',
    },
    saveLoading: {
      type: Boolean,
      default: false,
    },
  },
  data() {
    return {
      verifyFormData: {
        checkStatus: '',
        companyHave: '',
        storageLocation: '',
        rejectMark: '',
        sampleId: '',
      },
      verifyRules: {
        checkStatus: [
          { required: true, message: '请选择审核结果', trigger: 'change' },
        ],
        companyHave: [
          {
            required: true,
            message: '请选择采购仓库是否有实物',
            trigger: 'change',
          },
        ],
        storageLocation: [
          { required: true, message: '请输入实物存放位置', trigger: 'blur' },
        ],
        rejectMark: [
          { required: true, message: '请输入审核不通过原因', trigger: 'blur' },
        ],
      },
      maxlength: 60,
    };
  },
  mounted() {},
  methods: {
    // to样品列表页
    toSamplePage(
      status,
      paramName = 'sample-manage/sample-list',
      name = '样品列表',
    ) {
      this.$store.dispatch('tagsView/jumpAndClosePage', {
        close: {
          name: this.$route.meta.title,
          href: this.$route.path,
        },
        open: {
          name: name,
          href: `/${paramName}`,
        },
      });
      this.$router.push({
        name: paramName,
        params: {
          status,
          row: this.row,
        },
      });
    },
    checkStatusChange() {
      this.verifyFormData.rejectMark = '';
      this.verifyFormData.companyHave = '';
      this.$refs.verifyFormData.clearValidate();
    },
    companyHaveChange(val) {
      this.verifyFormData.companyHave = val;
      this.verifyFormData.storageLocation = '';
    },
    // 审核
    verifyBtn() {
      this.$emit('verify-btn', 'submit');
    },
  },
};
</script>

<style lang="less" scoped>
</style>
